import { normalizeOrganizationId } from "@/shared/organizations/organization-id";
import { useQuery } from "@tanstack/react-query";
import { AUDITED_READ_OPTIONS } from "@/shared/api/audited-read";
import { httpClient } from "@/shared/api/http-client";
import { organizationDetailPath } from "./build-organizations-query";
import { ORGANIZATIONS_QUERY_KEY } from "./constants";
import type { AdminOrganization } from "./types";

/**
 * `GET /api/admin/organizations/:id` — the organization with its owner (display
 * name only) and member / invitation / location counts. Needs
 * `org.members.read`; the API audits the read and throttles it, so a failure
 * is never retried automatically (a 404 `ORGANIZATION_NOT_FOUND` is final).
 */
export function useOrganization(organizationId: string) {
  return useQuery({
    queryKey: [
      ...ORGANIZATIONS_QUERY_KEY,
      "organization",
      normalizeOrganizationId(organizationId) ?? "",
      "detail",
    ] as const,
    queryFn: () => httpClient<AdminOrganization>(organizationDetailPath(organizationId)),
    enabled: normalizeOrganizationId(organizationId) !== null,
    ...AUDITED_READ_OPTIONS,
  });
}
